'use strict';

var date = new Date();

module.exports = function ( timestamp ) {
    var hh, mm;

    date.setTime(timestamp);
    hh = date.getHours();
    mm = date.getMinutes();

    if ( hh < 10 ) {
        hh = '0' + hh;
    }
    if ( mm < 10 ) {
        mm = '0' + mm;
    }

    return hh + ':' + mm;
};
